/* eslint-disable @nx/enforce-module-boundaries */
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import { VoiceQuestionConfig } from '@hyper-inferno/voice-core';

export class VoiceHandler implements QuestionHandler<VoiceQuestionConfig> {
  async buildConfig(el: any, ctx: ITransformationContext) {
    return el.config;
  }
}
